import StatementTop from "../../../components/elements/statements/statementTop";
import StatementBottom from "../../../components/elements/statements/statementBottom";
import CInput from "../../../components/elements/customInput";
import CCheckbox from "../../../components/elements/customCheckbox";
import CTextarea from "../../../components/elements/customTextarea";
import CSelect from "../../../components/elements/customSelect";

import { scrollToElement } from "../../../helpers/helpers";
import { mapState } from "ui.vue3.vuex";

import { StatementComponentNames } from "../../../helpers/data";
import RefundStatementStepTwo from "./step-2";
import RefundStatementStepFour from "./step-4";

const RefundStatementStepThree = {
    template: /*html*/ `
  <form class="statement-form" action="#">
    <StatementTop
      active-step="3"
      step-amount="4"
    />

    <div class="statement-middle">
      <div class="statement__step statement__step-3">
        <div class="area">
          <div class="area-form">
            <p class="h5">Причина возврата<span class="text">(не обязательно)</span></p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <CTextarea
                  :ref="ref_names.refund_cause"
                  :name="refund_cause.name"
                  :title="refund_cause.title"
                  :required="refund_cause.required"
                  :validation="refund_cause.validation"
                  v-model="data.refund_cause"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Прошу перечислить сумму платежа за вычетом комиссии   АО НКО «ЭЛЕКСНЕТ» за перевод денежных средств по следующим реквизитам (выбрать нужное):<span></span></p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <div class="statement-tabs">
                
                  <div class="statement-tabs__list desktop">
                    <a class="tab-card" :class="{active: data.active_tab === tabs.card}" @click.prevent="setActiveTab(tabs.card, true)">
                      <svg class="icon icon-statement-tab-card-icon">
                        <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#statement-tab-card-icon'"></use>
                      </svg><span>На карту (Visa, Mastercard, МИР)</span>
                    </a>
                    <a class="tab-requisites" :class="{active: data.active_tab === tabs.requisites}" @click.prevent="setActiveTab(tabs.requisites, true)">
                      <svg class="icon icon-statement-tab-requisites-icon">
                        <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#statement-tab-requisites-icon'"></use>
                      </svg><span>На банковские реквизиты</span>
                    </a>
                    <a class="tab-mobile" :class="{active: data.active_tab === tabs.mobile}" @click.prevent="setActiveTab(tabs.mobile, true)">
                      <svg class="icon icon-statement-tab-mobile-icon">
                        <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#statement-tab-mobile-icon'"></use>
                      </svg><span>На мобильный телефон</span>
                    </a>
                    <a class="tab-other" :class="{active: data.active_tab === tabs.other}" @click.prevent="setActiveTab(tabs.other, true)">
                      <svg class="icon icon-statement-tab-other-icon">
                        <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#statement-tab-other-icon'"></use>
                      </svg><span>Другое</span>
                    </a>
                  </div>

                  <div class="statement-tabs__list mobile">
                    <CSelect
                      :name="mobile_tabs_select.name"
                      :title="mobile_tabs_select.title"
                      :required="mobile_tabs_select.required"
                      :validation="mobile_tabs_select.validation"
                      :options="mobile_tabs_options"
                      @selected_option="selectMobileTab"
                      :initial-value="data.mobile_tabs_option"
                      select-id="mobile_tabs_options"
                    />
                  </div>

                  <div class="statement-tabs__main">
                    <div class="statement-tabs__content card" v-if="data.active_tab === tabs.card">
                      <div class="area">
                        <div class="area-form">
                          <div class="area-form__fields grid col-xxl-2 col-md-1">
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.card_number"
                                :name="card_number.name"
                                :title="card_number.title"
                                :type="card_number.type"
                                :required="card_number.required"
                                :validation="card_number.validation"
                                v-model="data.card_number"
                                :mask="card_number.mask"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.bank_title"
                                :name="bank_title.name"
                                :title="bank_title.title"
                                :type="bank_title.type"
                                :required="bank_title.required"
                                :validation="bank_title.validation"
                                v-model="data.bank_title"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="area">
                        <div class="area-form">
                          <p class="h5">Личные данные</p>
                          <div class="area-form__fields grid col-xxl-2 col-md-1">
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_last_name"
                                :name="transaction_last_name.name"
                                :title="transaction_last_name.title"
                                :type="transaction_last_name.type"
                                :required="transaction_last_name.required"
                                :validation="transaction_last_name.validation"
                                v-model="data.transaction_last_name"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_first_name"
                                :name="transaction_first_name.name"
                                :title="transaction_first_name.title"
                                :type="transaction_first_name.type"
                                :required="transaction_first_name.required"
                                :validation="transaction_first_name.validation"
                                v-model="data.transaction_first_name"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_middle_name"
                                :name="transaction_middle_name.name"
                                :title="transaction_middle_name.title"
                                :type="transaction_middle_name.type"
                                :required="transaction_middle_name.required"
                                :validation="transaction_middle_name.validation"
                                v-model="data.transaction_middle_name"
                                :disabled="data.is_transaction_middle_name_required"
                              />
                            </div>
                            <div class="area-form__fields-item flex align-center">
                              <CCheckbox
                                :title="transaction_no_middle_name.title"
                                :checkbox-id="transaction_no_middle_name.id"
                                :check-var="data.is_transaction_middle_name_required"
                                @on_change="onNoMiddleNameChange"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="statement-tabs__content requisites" v-if="data.active_tab === tabs.requisites">
                      <div class="area">
                        <div class="area-form">
                          <div class="area-form__fields grid col-xxl-1">
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.bank_title"
                                :name="bank_title.name"
                                :title="bank_title.title"
                                :type="bank_title.type"
                                :required="bank_title.required"
                                :validation="bank_title.validation"
                                v-model="data.bank_title"
                              />
                            </div>
                            <div class="area-form__fields grid col-xxl-2 col-md-1">
                              <div class="area-form__fields-item">
                                <CInput
                                  :ref="ref_names.bank_bik"
                                  :name="bank_bik.name"
                                  :title="bank_bik.title"
                                  :type="bank_bik.type"
                                  :required="bank_bik.required"
                                  :validation="bank_bik.validation"
                                  v-model="data.bank_bik"
                                  :mask="bank_bik.mask"
                                />
                              </div>
                              <div class="area-form__fields-item">
                                <CInput
                                  :ref="ref_names.client_rs_number"
                                  :name="client_rs_number.name"
                                  :title="client_rs_number.title"
                                  :type="client_rs_number.type"
                                  :required="client_rs_number.required"
                                  :validation="client_rs_number.validation"
                                  v-model="data.client_rs_number"
                                  :mask="client_rs_number.mask"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="area">
                        <div class="area-form">
                          <p class="h5">Данные владельца счета</p>
                          <div class="area-form__fields grid col-xxl-2 col-md-1">
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_last_name"
                                :name="transaction_last_name.name"
                                :title="transaction_last_name.title"
                                :type="transaction_last_name.type"
                                :required="transaction_last_name.required"
                                :validation="transaction_last_name.validation"
                                v-model="data.transaction_last_name"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_first_name"
                                :name="transaction_first_name.name"
                                :title="transaction_first_name.title"
                                :type="transaction_first_name.type"
                                :required="transaction_first_name.required"
                                :validation="transaction_first_name.validation"
                                v-model="data.transaction_first_name"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_middle_name"
                                :name="transaction_middle_name.name"
                                :title="transaction_middle_name.title"
                                :type="transaction_middle_name.type"
                                :required="transaction_middle_name.required"
                                :validation="transaction_middle_name.validation"
                                v-model="data.transaction_middle_name"
                                :disabled="data.transaction_is_middle_name_required"
                              />
                            </div>
                            <div class="area-form__fields-item flex align-center">
                              <CCheckbox
                                :title="transaction_no_middle_name.title"
                                :checkbox-id="transaction_no_middle_name.id"
                                :check-var="data.transaction_is_middle_name_required"
                                @on_change="onNoMiddleNameChange"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_phone"
                                :name="transaction_phone.name"
                                :title="transaction_phone.title"
                                :type="transaction_phone.type"
                                :required="transaction_phone.required"
                                :validation="transaction_phone.validation"
                                v-model="data.transaction_phone"
                                :mask="transaction_phone.mask"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="statement-tabs__content mobile" v-if="data.active_tab === tabs.mobile">
                      <div class="area">
                        <div class="area-form">
                          <div class="area-form__fields grid col-xxl-2 col-md-1">
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.mobile_phone_provider"
                                :name="mobile_phone_provider.name"
                                :title="mobile_phone_provider.title"
                                :type="mobile_phone_provider.type"
                                :required="mobile_phone_provider.required"
                                :validation="mobile_phone_provider.validation"
                                v-model="data.mobile_phone_provider"
                              />
                            </div>
                            <div class="area-form__fields-item">
                              <CInput
                                :ref="ref_names.transaction_phone"
                                :name="transaction_phone.name"
                                :title="transaction_phone.title"
                                :type="transaction_phone.type"
                                :required="transaction_phone.required"
                                :validation="transaction_phone.validation"
                                v-model="data.transaction_phone"
                                :mask="transaction_phone.mask"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="statement-tabs__content other" v-if="data.active_tab === tabs.other">
                      <div class="area">
                        <div class="area-form">
                          <div class="area-form__fields grid col-xxl-1">
                            <div class="area-form__fields grid col-xxl-2 col-md-1">
                              <div class="area-form__fields-item">
                                <CInput
                                  :ref="ref_names.offer_name"
                                  :name="offer_name.name"
                                  :title="offer_name.title"
                                  :type="offer_name.type"
                                  :required="offer_name.required"
                                  :validation="offer_name.validation"
                                  v-model="data.offer_name"
                                />
                              </div>
                              <div class="area-form__fields-item">
                                <CInput
                                  :ref="ref_names.offer_id"
                                  :name="offer_id.name"
                                  :title="offer_id.title"
                                  :type="offer_id.type"
                                  :required="offer_id.required"
                                  :validation="offer_id.validation"
                                  v-model="data.offer_id"
                                />
                              </div>
                            </div>
                            <div class="area-form__fields grid col-xxl-1">
                              <div class="area-form__fields-item">
                                <CTextarea
                                  :ref="ref_names.comment"
                                  :name="comment.name"
                                  :title="comment.title"
                                  :required="comment.required"
                                  :validation="comment.validation"
                                  v-model="data.comment"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <StatementBottom 
      :next-btn="next_btn"
      :back-btn="back_btn"
      @back_clicked="onBackClicked"
      @next_clicked="onNextClicked"
    />
  </form>
  `,

    name: StatementComponentNames.refund_of_funds.refund_three,

    props: {
        statementAnchor: {
            type: String,
            default: "",
        },

        goToComponent: {
            type: Function,
        },
    },

    computed: {
        ...mapState({
            statement_data: (state) => state.refundStatement.data,
        }),
    },

    data() {
        return {
            next_btn: {
                show: true,
                text: "Продолжить",
                class: "",
            },

            back_btn: {
                show: true,
                text: "Назад",
                class: "",
            },

            mobile_tabs_select: {
                name: "mobile_tabs_select",
                required: true,
                validation: [],
            },

            mobile_tabs_options: [
                {
                    icon: "/icons/sprite.svg#statement-tab-card-icon",
                    text: "На карту (Visa, Mastercard, МИР)",
                    id: "card",
                    selected: true,
                },

                {
                    icon: "/icons/sprite.svg#statement-tab-requisites-icon",
                    text: "На банковские реквизиты",
                    id: "requisites",
                    selected: false,
                },

                {
                    icon: "/icons/sprite.svg#statement-tab-mobile-icon",
                    text: "На мобильный телефон",
                    id: "mobile",
                    selected: false,
                },

                {
                    icon: "/icons/sprite.svg#statement-tab-other-icon",
                    text: "Другое",
                    id: "other",
                    selected: false,
                },
            ],

            refund_cause: {
                name: "refund_cause",
                title: "Причина возврата",
                required: false,
                validation: [["optional"], ["max", 300]],
            },

            card_number: {
                name: "card_number",
                title: "Номер карты",
                required: true,
                type: "text",
                validation: [["required"], ["min", 19]],
                mask: {
                    mask: "9999 9999 9999 9999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            transaction_last_name: {
                name: "cyrilic",
                title: "Фамилия",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-Я\s\W]+$/i]],
            },

            transaction_first_name: {
                name: "cyrilic",
                title: "Имя",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-Я\s\W]+$/i]],
            },

            transaction_middle_name: {
                name: "cyrilic",
                title: "Отчество",
                required: false,
                type: "text",
                validation: [["required"], ["matches", /^[А-Я\s\W]+$/i]],
            },

            transaction_no_middle_name: {
                title: "Нет отчества",
                id: "transaction_no_middle_name",
            },

            bank_title: {
                name: "bank_title",
                title: "Наименование банка",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            bank_bik: {
                name: "digits",
                title: "Бик банка",
                required: true,
                type: "text",
                validation: [["required"], ["min", 9]],
                mask: {
                    mask: "999999999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            client_rs_number: {
                name: "digits",
                title: "Номер лицевого счета",
                required: true,
                type: "text",
                validation: [["required"], ["min", 20]],
                mask: {
                    mask: "99999999999999999999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            transaction_phone: {
                name: "phone",
                title: "Номер мобильного телефона",
                required: true,
                type: "text",
                validation: [["optional"], ["min", 18]],
                mask: {
                    mask: "+7 (999) 999-99-99",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            mobile_phone_provider: {
                name: "mobile_phone_provider",
                title: "Оператор сотовой связи",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            offer_name: {
                name: "offer_name",
                title: "Наименование услуги",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            offer_id: {
                name: "offer_id",
                title: "Идентификатор (счет, договор и т.д.)",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            comment: {
                name: "comment",
                title: "Комментарий",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            data: {
                refund_cause: "",
                card_number: "",
                transaction_last_name: "",
                transaction_first_name: "",
                transaction_middle_name: "",
                transaction_is_middle_name_required: false,

                transaction_phone: "",
                client_rs_number: "",
                bank_bik: "",
                bank_title: "",

                mobile_phone_provider: "",

                offer_name: "",
                offer_id: "",
                comment: "",

                active_tab: null,

                mobile_tabs_option: {
                    text: null,
                    id: null,
                    icon: false,
                    selected: false,
                },
            },

            tabs: {
                card: "card",
                requisites: "requisites",
                mobile: "mobile",
                other: "other",
            },

            ref_names: {
                refund_cause: "refund_cause",
                transaction_provider: "transaction_provider",
                card_number: "card_number",
                transaction_last_name: "transaction_last_name",
                transaction_first_name: "transaction_first_name",
                transaction_middle_name: "transaction_middle_name",
                transaction_phone: "transaction_phone",
                client_rs_number: "client_rs_number",
                bank_bik: "bank_bik",
                bank_title: "bank_title",
                mobile_phone_provider: "mobile_phone_provider",
                offer_name: "offer_name",
                offer_id: "offer_id",
                comment: "comment",
            },

            ref_order: [],

            refs_with_errors: [],

            form_has_errors: false,
        };
    },

    watch: {
        "data.transaction_last_name": function () {
            if (this.data.transaction_last_name) {
                this.data.transaction_last_name =
                    this.data.transaction_last_name[0].toUpperCase() +
                    this.data.transaction_last_name.substring(1).toLowerCase();
            }
        },

        "data.transaction_first_name": function () {
            if (this.data.transaction_first_name) {
                this.data.transaction_first_name =
                    this.data.transaction_first_name[0].toUpperCase() +
                    this.data.transaction_first_name.substring(1).toLowerCase();
            }
        },

        "data.transaction_middle_name": function () {
            if (this.data.transaction_middle_name) {
                this.data.transaction_middle_name =
                    this.data.transaction_middle_name[0].toUpperCase() +
                    this.data.transaction_middle_name.substring(1).toLowerCase();
            }
        },
    },

    created() {
        this.getStoreData();

        if (!this.data.active_tab) {
            this.data.active_tab = this.tabs.card;
        }

        this.setActiveTab(this.data.active_tab, false);
        this.fillRefOrder(this.data.active_tab);
        this.onNoMiddleNameChange();
    },

    methods: {
        onBackClicked() {
            this.setStatementData();
            this.scrollToTop();
            this.goToComponent({ component: RefundStatementStepTwo });
        },

        async onNextClicked() {
            this.setStatementData();

            await this.submitForm();

            if (!this.form_has_errors) {
                this.scrollToTop();
                this.goToComponent({ component: RefundStatementStepFour });
            }
        },

        fillRefOrder() {
            switch (this.data.active_tab) {
                case this.tabs.card: {
                    if (this.data.is_transaction_middle_name_required) {
                        this.ref_order = [
                            this.ref_names.refund_cause,
                            this.ref_names.card_number,
                            this.ref_names.bank_title,
                            this.ref_names.transaction_last_name,
                            this.ref_names.transaction_first_name,
                            this.ref_names.transaction_middle_name,
                        ];
                    }

                    if (!this.data.is_transaction_middle_name_required) {
                        this.ref_order = [
                            this.ref_names.refund_cause,
                            this.ref_names.card_number,
                            this.ref_names.bank_title,
                            this.ref_names.transaction_last_name,
                            this.ref_names.transaction_first_name,
                        ];
                    }
                    break;
                }

                case this.tabs.requisites: {
                    this.ref_order = [
                        this.ref_names.refund_cause,
                        this.ref_names.bank_title,
                        this.ref_names.bank_bik,
                        this.ref_names.client_rs_number,
                        this.ref_names.transaction_last_name,
                        this.ref_names.transaction_first_name,
                        this.ref_names.transaction_middle_name,
                        this.ref_names.transaction_phone,
                    ];
                    break;
                }

                case this.tabs.mobile: {
                    this.ref_order = [
                        this.ref_names.refund_cause,
                        this.ref_names.mobile_phone_provider,
                        this.ref_names.transaction_phone,
                    ];
                    break;
                }

                case this.tabs.other: {
                    this.ref_order = [
                        this.ref_names.refund_cause,
                        this.ref_names.offer_name,
                        this.ref_names.offer_id,
                        this.ref_names.comment,
                    ];
                    break;
                }
            }
        },

        validateForm() {
            this.refs_with_errors = [];
            this.ref_order.forEach((ref) => {
                const hasError = this.$refs[ref].hasValidationErrors();

                if (hasError) {
                    this.refs_with_errors.push(ref);
                }
            });
        },

        async submitForm() {
            this.form_has_errors = false;
            await this.$nextTick(() => {});

            this.validateForm();

            if (this.refs_with_errors.length) {
                this.form_has_errors = true;
                scrollToElement({
                    el: this.$refs[this.refs_with_errors[0]].$el,
                    time: 200,
                    animation: "swing",
                    offset: 100,
                });
            }
        },

        onNoMiddleNameChange(val, id) {
            this.data.is_transaction_middle_name_required = val;

            if (this.data.is_transaction_middle_name_required) {
                this.transaction_middle_name.validation = [["optional"]];
                this.data.transaction_middle_name = null;
            } else {
                this.transaction_middle_name.validation = [["required"], ["matches", /^[А-Я\s\W]+$/i]];
            }

            this.fillRefOrder(this.data.active_tab);
        },

        setActiveTab(tab, need_clear) {
            this.data.active_tab = tab;

            const selected_mobile_tab = this.mobile_tabs_options.find((option) => option.selected);
            // this.mobile_tabs_options[selected_mobile_tab.id].selected = false;
            selected_mobile_tab.selected = false;

            const mobile_tab = this.mobile_tabs_options.find((option) => option.id === tab);
            // this.mobile_tabs_options[mobile_tab.id].selected = true;
            mobile_tab.selected = true;

            this.data.mobile_tabs_option.text = mobile_tab.text;
            this.data.mobile_tabs_option.id = mobile_tab.id;
            this.data.mobile_tabs_option.icon = mobile_tab.icon;
            this.data.mobile_tabs_option.selected = mobile_tab.selected;

            this.fillRefOrder(this.data.active_tab);
        },

        clearAllValues() {
            this.data.card_number = "";
            this.data.transaction_last_name = "";
            this.data.transaction_first_name = "";
            this.data.transaction_middle_name = "";
            this.data.transaction_is_middle_name_required = false;
            this.data.transaction_phone = "";
            this.data.client_rs_number = "";
            this.data.bank_bik = "";
            this.data.bank_title = "";
            this.data.mobile_phone_provider = "";
            this.data.offer_name = "";
            this.data.offer_id = "";
            this.data.comment = "";
        },

        selectMobileTab(option) {
            this.data.mobile_tabs_option.text = option.text;
            this.data.mobile_tabs_option.id = option.id;
            this.data.mobile_tabs_option.icon = option.icon;
            this.data.mobile_tabs_option.selected = option.selected;

            const selected_mobile_tab = this.mobile_tabs_options.find((item) => item.selected);
            selected_mobile_tab.selected = false;

            // this.mobile_tabs_options[option.id].selected = true;
            const mobile_tab = this.mobile_tabs_options.find((item) => item.id === option.id);
            mobile_tab.selected = true;

            this.data.active_tab = option.id;

            this.fillRefOrder(this.data.active_tab);
        },

        getStoreData() {
            this.data.refund_cause = this.statement_data.refund_cause;
            this.data.card_number = this.statement_data.card_number;
            this.data.transaction_last_name = this.statement_data.transaction_last_name;
            this.data.transaction_first_name = this.statement_data.transaction_first_name;
            this.data.transaction_middle_name = this.statement_data.transaction_middle_name;
            this.data.is_transaction_middle_name_required = this.statement_data.is_transaction_middle_name_required;
            this.data.transaction_phone = this.statement_data.transaction_phone;
            this.data.client_rs_number = this.statement_data.client_rs_number;
            this.data.bank_bik = this.statement_data.bank_bik;
            this.data.bank_title = this.statement_data.bank_title;
            this.data.mobile_phone_provider = this.statement_data.mobile_phone_provider;
            this.data.offer_name = this.statement_data.offer_name;
            this.data.offer_id = this.statement_data.offer_id;
            this.data.comment = this.statement_data.comment;
            this.data.active_tab = this.statement_data.active_tab;
            this.data.mobile_tabs_option.text = this.statement_data.mobile_tabs_option.text;
            this.data.mobile_tabs_option.id = this.statement_data.mobile_tabs_option.id;
            this.data.mobile_tabs_option.icon = this.statement_data.mobile_tabs_option.icon;
            this.data.mobile_tabs_option.selected = this.statement_data.mobile_tabs_option.selected;
        },

        setStatementData() {
            this.$store.commit("refundStatement/setThirdStepData", { data: this.data });
        },

        scrollToTop() {
            const el = document.querySelector(`#${this.statementAnchor}`);

            if (el) {
                scrollToElement({ el: el, time: 200, animation: "swing" });
            }
        },
    },

    components: {
        StatementTop,
        StatementBottom,
        CInput,
        CCheckbox,
        CTextarea,
        CSelect,
        RefundStatementStepTwo,
        RefundStatementStepFour,
    },
};

export default RefundStatementStepThree;
